/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {UserModal} from '../../modals/user-create-modal-stepper/UserModal'
import {CompanyModal} from '../../modals/company-edit-modal/CompanyModal'
import {useAuth} from '../../../../app/modules/auth'
import {UserAvatar} from '../../../helpers'
import {useIntl} from 'react-intl'
import {PasswordModal} from '../../modals/password-modal/PasswordModal'
import {useThemeMode} from '../theme-mode/ThemeModeProvider'
import {startTour} from '../../../../app/modules/tutorial/startTour'
import {useReopenOnboarding} from '../../../../app/modules/onboarding/hooks/useOnboardingProgress'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const reopenOnboarding = useReopenOnboarding()
  const {currentUser, logout} = useAuth()
  const {mode, updateMode, updateMenuMode} = useThemeMode()
  const [showModalStepper, setShowModalStepper] = useState<boolean>(false)
  const [showModalCompany, setShowModalCompany] = useState<boolean>(false)
  const [showModalPassword, setShowModalPassword] = useState<boolean>(false)
  const openEditModal = () => {
    setShowModalStepper(true)
  }
  const openEditModalComapany = () => {
    setShowModalCompany(true)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary dash-menu-hover-green fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <UserAvatar
            name={currentUser?.name ?? ''}
            avatar={currentUser?.avatar}
            sizeClass='symbol-50px'
            className='me-5'
            imgClassName='object-fit-cover'
          />

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.name}
              {currentUser?.administrator || currentUser?.manager ? (
                <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                  {currentUser?.administrator ? 'Admin' : 'Gestor'}
                </span>
              ) : null}
            </div>
            <span
              className='fw-bold text-muted fs-7 d-block w-100 text-break'
              style={{overflowWrap: 'anywhere'}}
            >
              {currentUser?.email}
            </span>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5'>
        <a className='menu-link px-5' onClick={openEditModal}>
          <span className='menu-icon'><i className='bi bi-person'></i></span>
          <span className='menu-title'>Meu Perfil</span>
          {/* {intl.formatMessage({id: 'TABLE.GENERAL.LABEL.EDIT'})} */}
        </a>
        <UserModal
          show={showModalStepper}
          handleClose={() => setShowModalStepper(false)}
          userId={currentUser?.id}
        />
      </div>
      {!!currentUser?.administrator && (
        <>
          <div className='menu-item px-5'>
            <a className='menu-link px-5' onClick={openEditModalComapany}>
              <span className='menu-icon'><i className='bi bi-building'></i></span><span className='menu-title'>Conta da Empresa</span>
            </a>
          </div>
          <CompanyModal
            show={showModalCompany}
            handleClose={() => setShowModalCompany(false)}
            companyId={currentUser?.instance_id}
          />

          <div className='menu-item px-5'>
            <Link to='/billings' className='menu-link px-5'>
              <span className='menu-icon'><i className='bi bi-credit-card'></i></span><span className='menu-title'>{intl.formatMessage({id: 'MENU.BILLING'})}</span>
            </Link>
          </div>
        </>
      )}

      {!currentUser?.external_user && (
        <div className='menu-item px-5'>
          <Link
            to='/indicacoes'
            className='menu-link px-5 d-flex align-items-center flex-wrap gap-2'
          >
            <span className='menu-icon'><i className='bi bi-gift'></i></span>
            <span className='menu-title'>Indicações</span>
          </Link>
        </div>
      )}

      {!!(currentUser?.administrator || currentUser?.manager) && (
        <div
          className='menu-item px-5'
          data-kt-menu-trigger='hover'
          data-kt-menu-placement='left-start'
          data-kt-menu-flip='bottom'
        >
          <a href='#' className='menu-link px-5'>
            <span className='menu-icon'><i className='bi bi-sliders'></i></span><span className='menu-title'>Configurações Gerais</span>
            <span className='menu-arrow'></span>
          </a>

          <div className='menu-sub menu-sub-dropdown w-175px py-4'>
            {/* <div className='menu-item px-3'>
              <Link to='/stages' className='menu-link d-flex flex-stack px-5'>
                {intl.formatMessage({id: 'MENU.STAGES'})}
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title={intl.formatMessage({id: 'MENU.STAGES'})}
                ></i>
              </Link>
            </div> */}

            <div className='menu-item px-3'>
              <Link to='/configs' className='menu-link d-flex flex-stack px-5'>
                Configurações da {currentUser?.instance?.name}
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='View your statements'
                ></i>
              </Link>
            </div>

            {/* <div className='separator my-2'></div>

              <div className='menu-item px-3'>
                <div className='menu-content px-3'>
                  <label className='form-check form-switch form-check-custom form-check-solid'>
                    <input
                      className='form-check-input w-30px h-20px'
                      type='checkbox'
                      value='1'
                      defaultChecked={true}
                      name='notifications'
                    />
                    <span className='form-check-label text-muted fs-7'>Notificações</span>
                  </label>
                </div>
              </div> */}
          </div>
        </div>
      )}

      <div className='menu-item px-5'>
        <div className='menu-link px-5' onClick={() => setShowModalPassword(true)}>
          <span className='menu-icon'><i className='bi bi-key'></i></span><span className='menu-title'>{intl.formatMessage({id: 'MENU.CHANGE_PASSWORD'})}</span>
        </div>
      </div>
      <PasswordModal show={showModalPassword} handleClose={() => setShowModalPassword(false)} />
      {/* Tema: só aparece aqui no mobile (o ícone dedicado da navbar some abaixo do
          breakpoint lg pra não disputar espaço com os ícones essenciais). */}
      <div className='menu-item px-5 d-lg-none'>
        <div
          className='menu-link px-5'
          onClick={() => {
            const next = mode === 'dark' ? 'light' : 'dark'
            updateMenuMode(next)
            updateMode(next)
          }}
        >
          <span className='menu-icon'><i className={mode === 'dark' ? 'bi bi-sun' : 'bi bi-moon-stars'}></i></span><span className='menu-title'>{mode === 'dark' ? 'Tema claro' : 'Tema escuro'}</span>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-5 d-lg-none'>
        <a
          href='#'
          className='menu-link px-5'
          onClick={(event) => {
            event.preventDefault()
            reopenOnboarding()
          }}
        >
          <span className='menu-icon'><i className='bi bi-list-check'></i></span><span className='menu-title'>{intl.formatMessage({id: 'MENU.FIRST_STEPS'})}</span>
        </a>
      </div>
      <div className='menu-item px-5 d-lg-none'>
        <a
          href='#'
          className='menu-link px-5'
          onClick={(event) => {
            event.preventDefault()
            startTour()
          }}
        >
          <span className='menu-icon'><i className='bi bi-compass'></i></span><span className='menu-title'>{intl.formatMessage({id: 'MENU.RE_DO_TOUR'})}</span>
        </a>
      </div>
      <div className='menu-item px-5 d-lg-none'>
        <a
          href='https://help.taskrush.com.br/'
          target='_blank'
          rel='noreferrer'
          className='menu-link px-5'
        >
          <span className='menu-icon'><i className='bi bi-info-circle'></i></span><span className='menu-title'>{intl.formatMessage({id: 'MENU.HELP'})}</span>
        </a>
      </div>
      <div className='separator my-2 d-lg-none'></div>
      {/* <Languages /> */}
      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Configurar notificações
        </Link>
      </div> */}
      {currentUser?.channels_enabled && (
        <div className='menu-item px-5'>
          <Link to='/meus-canais' className='menu-link px-5'>
            <span className='menu-icon'><i className='bi bi-chat-dots'></i></span><span className='menu-title'>Meus canais</span>
          </Link>
        </div>
      )}
      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          <span className='menu-icon'><i className='bi bi-box-arrow-right'></i></span>
          <span className='menu-title'>Sair</span>
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
